import e from "../../utils/classNames.js";
import { normalizeIconName as t } from "../../utils/iconNames.js";
import { useRef as n } from "react";
import { noop as r } from "es-toolkit/compat";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/radiobutton/RadioButton.tsx
var o = (e) => {
	let { iconName: n, icon: r, iconSize: o, iconLabelPosition: s, text: c } = e, l = n ?? r ?? "", u = {
		width: `${o}px`,
		height: `${o}px`,
		fontSize: `${o}px`,
		lineHeight: `${o}px`
	};
	return /* @__PURE__ */ a("span", {
		className: `radio-icon label-${s}`,
		children: [/* @__PURE__ */ i("span", {
			className: `uikit-icon ${t(l)}`,
			style: u
		}), /* @__PURE__ */ i("span", {
			className: "radio-label",
			children: c
		})]
	});
}, s = (t) => {
	let { iconName: s, icon: c, iconLabelPosition: l = "vertical", iconSize: u = 16, label: d, onClick: f = r, onChange: p = r, checked: m, defaultChecked: h, disabled: g = !1, className: _, inline: v = !1, right: y = !1, custom: b = !1, name: x, value: S, tabIndex: C = 0, inputRef: w, children: T, ...E } = t, D = s ?? c ?? "", O = m != null, k = n(null), A = (e) => {
		switch (e.key) {
			case " ":
			case "Enter": j(e);
		}
	}, j = (e) => {
		if (e.preventDefault(), !g) {
			if (O) {
				p(e);
				return;
			}
			if (k.current) {
				let e = k.current.firstChild;
				e.checked = !e.checked;
			}
		}
	}, M = d || T, N = e("radio", v && "radio-inline", _), P = e(y && "icon-right", _), F = !!D, I = b && T, L = !D && !b;
	return /* @__PURE__ */ a("label", {
		...E,
		className: N,
		tabIndex: C,
		onKeyDown: A,
		ref: k,
		children: [
			/* @__PURE__ */ i("input", {
				type: "radio",
				defaultChecked: h,
				checked: m,
				disabled: g,
				className: P,
				ref: w,
				onClick: f,
				onChange: O ? p : void 0,
				name: x,
				value: S
			}),
			F && /* @__PURE__ */ i(o, {
				iconName: D,
				iconSize: u,
				iconLabelPosition: l,
				text: M
			}),
			L && /* @__PURE__ */ i("span", {
				className: "radio-text",
				children: /* @__PURE__ */ i("span", { children: M })
			}),
			I && T
		]
	});
};
s.ICON_LABEL_VERTICAL = "vertical", s.ICON_LABEL_HORIZONTAL = "horizontal";
//#endregion
export { s as default };

//# sourceMappingURL=RadioButton.js.map